<template>
  <v-timeline-item
    v-if="value && value.visibilidade"
    :color="cor"
    :icon="value.icone"
    dark
  >
    <v-card
      :color="cor"
      :loading="typeof value.progresso === 'number' && prazo && prazo.status !== 'FUTURO'"
      class="elevation-2"
      dark
    >
      <!-- Título -->
      <v-card-title>
        <span class="body-1 font-weight-bold text-sm-h6 text-break mr-8">{{ value.titulo }}</span>
        <v-spacer />

        <!-- Botão de expansão -->
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              icon
              absolute
              right
              top
              @click="toogleExpand"
              v-on="on"
            >
              <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
            </v-btn>
          </template>
          <span>Clique no botão para {{ expand ? 'ocultar' : 'expandir' }}</span>
        </v-tooltip>
      </v-card-title>

      <!-- Subtítulo -->
      <v-card-subtitle v-if="prazo" v-show="expand">
        <span>{{ prazo.periodo }}</span>
        <v-spacer />

        <!-- Área de Aviso -->
        <v-tooltip
          v-if="value.aviso"
          max-width="500"
          top
        >
          <template v-slot:activator="{ on }">
            <v-badge
              v-if="value.aviso.icone"
              :color="`${value.aviso.cor} lighten-2`"
              overlap
            >
              <template v-slot:badge>
                <v-icon color="black">{{ value.aviso.icone }}</v-icon>
              </template>
              <v-chip
                label
                small
                outlined
                v-on="on"
              >
                <strong>{{ value.aviso.texto }}</strong>
              </v-chip>
            </v-badge>
            <v-chip
              v-else
              label
              small
              outlined
              v-on="on"
            >
              <strong>{{ value.aviso.texto }}</strong>
            </v-chip>
          </template>
          <span>{{ value.aviso.descricao ? value.aviso.descricao : value.aviso.texto }}</span>
        </v-tooltip>
      </v-card-subtitle>

      <!-- Conteúdo -->
      <v-card-text
        v-show="expand"
        :class="$vuetify.theme.dark ? 'contrast' : 'white text--primary'"
      >
        <p v-for="(texto, index) in value.textos" :key="index" class="text-justify pt-4">{{ texto }}</p>
      </v-card-text>

      <!-- Botões -->
      <v-card-actions
        v-show="expand"
        :class="$vuetify.theme.dark ? 'contrast pa-2' : 'white text--primary pa-2'"
      >
        <v-chip
          v-if="prazo && value.exibeStatus"
          :color="prazo.cor"
          class="mr-1 pa-1"
          outlined
          small
        >
          <v-icon class="mr-1">{{ prazo.icone }}</v-icon>
          {{ prazo.descricao }}
        </v-chip>
        <v-spacer />
        <v-btn
          v-if="!prazo || (prazo && prazo.status !== 'FUTURO')"
          :color="cor"
          outlined
          @click="to(value.link)"
        >
          {{ prazo && prazo.status === 'FINALIZADO' && value.exibeStatus ? 'visualizar' : 'Acessar' }}
        </v-btn>
      </v-card-actions>

      <!-- Barra de Progresso -->
      <template v-slot:progress>
        <v-progress-linear
          :value="value.progresso"
          :color="corProgress"
          background-color="grey lighten-2"
          height="22"
          rounded
        >
          <template v-slot:default>
            <strong class="grey--text text--darken-3">{{ value.progresso | decimal }}% concluído</strong>
          </template>
        </v-progress-linear>
      </template>
    </v-card>

    <!-- Ícone -->
    <template v-slot:icon>
      <!-- Se tiver prazo, exibe o ícone do timelene item com um ícone de status -->
      <v-badge
        v-if="prazo && value.exibeStatus"
        :color="prazo.cor"
        right
      >
        <template v-slot:badge>
          <v-icon v-if="prazo && value.exibeStatus">{{ prazo.icone }}</v-icon>
        </template>
        <v-icon>{{ value.icone }}</v-icon>
      </v-badge>

      <!-- Se não tiver prazo, exibe apenas o ícone do timeline item -->
      <v-icon v-else>{{ value.icone }}</v-icon>
    </template>
  </v-timeline-item>
</template>

<script>
import Data from '@/modules/data';

export default {
  name: 'AppTimelineItem',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => null,
    },
  },

  data() {
    return {
      expand: true,
    };
  },

  computed: {
    prazo() {
      const validDataInicial = this.value.dataInicial && Data.compare('isValid', { a: this.value.dataInicial });
      const validDataFinal = this.value.dataFinal && Data.compare('isValid', { a: this.value.dataFinal });
      let status;
      let periodo = '';

      if (validDataInicial) {
        // Atribui só a data inicial
        periodo = `Início em ${Data.format(this.value.dataInicial)}`;

        // Verifica se está antes do início do prazo
        if (Data.compare('isBefore', { b: this.value.dataInicial })) {
          status = {
            status: 'FUTURO',
            descricao: 'Agendado',
            icone: 'alarm',
            cor: 'grey',
          };
        }

        if (validDataFinal) {
          // Atribui as duas datas no período
          periodo = `De ${Data.format(this.value.dataInicial)} a ${Data.format(this.value.dataFinal)}`;

          // Verifica se está após o prazo
          if (Data.compare('isAfter', { b: this.value.dataFinal })) {
            status = {
              status: 'FINALIZADO',
              descricao: 'Prazo Finalizado',
              icone: 'event_busy',
              cor: 'warning',
            };
          }
        }

        // Se apos as verificações não tiver um status, está dentro do prazo
        if (!status) {
          status = {
            status: 'ATUAL',
            descricao: 'Em execução',
            icone: 'wifi_protected_setup',
            cor: 'secondary',
          };
        }
      } else if (validDataFinal) {
        // Atribui só a data final
        periodo = `Final em ${Data.format(this.value.dataFinal)}`;

        // Verifica se está após o prazo
        if (Data.compare('isAfter', { b: this.value.dataFinal })) {
          status = {
            status: 'FINALIZADO',
            descricao: 'Prazo Finalizado',
            icone: 'event_busy',
            cor: 'warning',
          };
        } else {
          status = {
            status: 'ATUAL',
            descricao: 'Em Execução',
            icone: 'timelapse',
            cor: 'secondary',
          };
        }
      }

      // Retorna os dados após as verificações
      if (status) {
        return {
          ...status,
          periodo,
        };
      }

      // Não tem prazo
      return null;
    },
    cor() {
      // Retorna cinza para indicar que o a etapa não está mais no prazo
      if (this.prazo && this.prazo.status === 'FINALIZADO' && this.value.exibeStatus) {
        return 'grey';
      }

      // Cor "primary" como padrão
      return this.value.cor ? this.value.cor : 'primary';
    },
    corProgress() {
      if (this.value.progresso) {
        if (this.value.progresso < 60) {
          return 'error lighten-1';
        }
        if (this.value.progresso < 100) {
          return 'warning lighten-1';
        }
        return 'success  lighten-1';
      }
      return '';
    },
  },

  methods: {
    to(path) {
      this.$router.push(path);
    },
    toogleExpand() {
      this.expand = !this.expand;
    },
  },
};
</script>
